<template>
    <el-dialog title="功能授权配置" :visible.sync="centerDialogVisible" width="48%" :close-on-click-modal="false">
        <div>
            <el-row>
                <el-col class="grid-content" :span="20">
                    <el-form>
                        <el-form-item label="菜单类型:">
                            <el-select v-model="value" multiple placeholder="请选择" style="width: 80%;">
                                <el-option v-for="item in options" :key="item.id" :label="item.menuName" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>

            <el-row v-for="(item, index) in menuList" :key="index" v-show="value.includes(item.id) || value.length == 0">
                <el-col class="grid-content" :span="6">
                    <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkedAll"
                        @change="handleCheckAllChange(item)" style="margin-left: 15px;">{{ item.menuName }}</el-checkbox>
                </el-col>
                <el-col class="grid-content" :span="18">
                    <el-row>
                        <el-col :span="6" v-for="it in item.listTreeMenus" :key="it.id">
                            <el-checkbox-group v-model="item.checkedMenu" @change="handleCheckedCitiesChange(item)">
                                <el-checkbox :label="it.id">{{ it.menuName }}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { Api_SuperAdmin, Api_Company } from '@/api/api.js'
export default {
    props: {

    },
    data() {
        return {
            centerDialogVisible: false,
            options: [],//查询框配置项
            value: [],//查询值
            menuList: [],//菜单列表
            menuValue: [],//勾选菜单
            menuType: 0,//区分超管和公司管理员
            backData: []
        }
    },
    mounted() {

    },
    methods: {  
        //全选框状态校验    isIndeterminate    checkedAll     结果
        //                      true        true or false     -
        //                      false           true          √
        //                      false           false         不勾
        checkAllOption(el) {
            if (el.checkedMenu.length === el.listTreeMenus.length) {
                el.isIndeterminate = false
                el.checkedAll = true
            } else if (el.checkedMenu.length < el.listTreeMenus.length) {
                el.isIndeterminate = true
                el.checkedAll = true
            }
            if (el.checkedMenu.length === 0) {
                el.isIndeterminate = false
                el.checkedAll = false
            }
        },
        async getMenus() {
            let res = await Api_SuperAdmin.getTopMenus()
            let { data, statusCode } = res.data
            if (statusCode === 200) {
                this.options = data
            }
        },
        async getMenuData() {
            //超管
            if (this.menuType == 0) {
                let params = {
                    menuName: "",
                    parentId: 0,
                    status: 1
                }
                let res = await Api_SuperAdmin.treeMenus(params)
                let { statusCode, data } = res.data
                if (statusCode === 200) {
                    this.menuList = data.map(item => {
                        return {
                            ...item,
                            checkedAll: false,
                            checkedMenu: [],
                            isIndeterminate: false,
                        }
                    })
                    this.dataBack()
                }
            } else if (this.menuType == 1) {
                //公司管理员
                let params = {
                    companyId: 0,
                    menuName: "",
                    parentId: 0
                }
                let res = await Api_Company.getCompanyMenus(params)
                let { statusCode, data } = res.data
                if (statusCode === 200) {
                    this.menuList = data.map(item => {
                        return {
                            ...item,
                            checkedAll: false,
                            checkedMenu: [],
                            isIndeterminate: false,
                        }
                    })
                    this.dataBack()
                }
            }
        },
        //数据回显
        dataBack() {
            console.log(this.menuList);
            this.menuList.forEach(el => {
                el.listTreeMenus.forEach(ell => {
                    if (this.backData.includes(String(ell.id))) {
                        el.checkedMenu.push(ell.id)
                        el.isIndeterminate = true
                    }
                })
                this.checkAllOption(el)
            })
        },
        open(val, haveID) { //val取值 0:超管  1：公司管理员
            //初始化
            this.menuType = val
            this.backData = haveID
            this.value = []
            this.getMenus()
            this.getMenuData()
            this.centerDialogVisible = true

        },
        close() {
            this.menuList = []
            this.centerDialogVisible = false
        },
        submit() {
            this.menuValue = []
            this.menuList.forEach(el => {
                el.checkedMenu.forEach(el => {
                    this.menuValue.push(el)
                })
            })
            this.$emit("submitHandle", this.menuValue)
            this.close()
        },
        handleCheckAllChange(el) {
            if (el.checkedMenu.length < el.listTreeMenus.length) {
                el.checkedMenu = el.listTreeMenus.map(option => option.id);
            } else {
                el.checkedMenu = [];
            }

            this.checkAllOption(el)
        },
        handleCheckedCitiesChange(el) {
            this.checkAllOption(el)
        }
    }
}
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
}
</style>